import React, { useEffect, useRef } from "react";
import { Combo } from "../combos/Combo";
import { useState } from "react";
import { Form } from "react-bootstrap";

export default function Tableros({ resultTipoTablero }) {
  const [tableroActivo, setTableroActivo] = useState(0);
  const refIframes = useRef({});
  const [urlTableroExtraer, setUrlTableroExtraer] = useState("");

  useEffect(() => {
    setTableroActivo(resultTipoTablero[0]?.id_tablero ?? 0);
    setUrlTableroExtraer(resultTipoTablero[0]?.url);
  }, [resultTipoTablero]);

  const onChangeFiltros = (target) => {
    const { value } = target;
    setTableroActivo(value);
    let index = target.selectedIndex;
    let url = target.options[index].getAttribute("data-tag");
    setUrlTableroExtraer(url);
  };

  return (
    <>
      <div className="flex-center_tablero contenedor-tablero-extraccion mt-3">
        <Form.Group
          style={{
            gridArea: "select",
            display: "flex",
            flexDirection: "column",
          }}
          className="mb-3"
        >
          <Form.Label className="label-forms-admin">Tablero</Form.Label>
          <Form.Select
            className="inputs-forms-admin focus-admin-register"
            onChange={({ target }) => onChangeFiltros(target)}
            name={"tablero"}
            value={tableroActivo}
          >
            {resultTipoTablero.map((e, i) => {
              return (
                <>
                  <option
                    key={e.id_combo}
                    data-tag={e.url}
                    value={e.id_tablero}
                  >
                    {e.nombre}
                  </option>
                </>
              );
            })}
          </Form.Select>
        </Form.Group>
        <Form.Group style={{ gridArea: "boton" }} className="mb-3">
          <a target="_blank" href={urlTableroExtraer}>
            <span className="icon-nueva-pagina"></span>
            Ampliar
          </a>
        </Form.Group>
      </div>
      {resultTipoTablero.map((item, index) => (
        <section
          className={"container container-tablero"}
          style={
            String(item.id_tablero) === String(tableroActivo)
              ? { display: "block" }
              : { display: "none" }
          }
          key={`frm${item.id_tablero}`}
          ref={(ref) => {
            refIframes.current[item.id_tablero] = ref; // took this from your guide's example.
          }}
        >
          <iframe
            id={`frm${item.id_tablero}`}
            src={item.url}
            title={item.nombre}
            className="container-forms"
          />
        </section>
      ))}
    </>
  );
}
